<template>
  <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
      <a class="nav-link active" id="v-pills-Current-tab" data-toggle="pill" href="#v-pills-Current" role="tab" aria-controls="v-pills-Current " aria-selected="true">Booking </a>
      <a class="nav-link" id="v-pills-History-tab" data-toggle="pill" href="#v-pills-History" role="tab" aria-controls="v-pills-History" aria-selected="false">You Booking</a>
     

    </div>

</template>

<script>
export default {
        name: 'Tap5'

    }
</script>

<style scoped>

.nav-pills .nav-link.active, .nav-pills .show>.nav-link {
    color: #00A1D5;
    background-color: none !important;
    border-bottom: 1px #646464 dotted;
}
.nav-pills .nav-link.active, .nav-pills .show>.nav-link {
    color: #fff;
 background-color: #007bff0a;;
}

.nav-pills .nav-link {
    border-radius: .1rem;
    border-bottom: 1px #646464 dashed;
    color: #285475;
    font-size: 17px;

}
.nav-pills .nav-link.active, .nav-pills .show>.nav-link {
    color: #fff;
    background-color: #285475 !important;
}

</style>